// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yxcR","clinicsSelect":"styles_clinicsSelect__1iNIA"};